import { TableRow, TableCell } from "@mui/material";
import React from "react";

const TableHeader = (props) => {
    return <TableRow className="table-header">
        <TableCell sx={{width: "200px"}}>Normalized</TableCell>
        <TableCell sx={{width: "200px"}}>Label</TableCell>
        <TableCell>Value</TableCell>
        <TableCell sx={{width: "100px", textAlign: "center"}}>Action</TableCell>
    </TableRow>
}

export default TableHeader;